import { Box, Container, Link, Stack, Typography } from '@mui/material';

export default function SiteFooter() {
  return (
    <Box component="footer" sx={{ borderTop: '1px solid', borderColor: 'divider', bgcolor: '#eaf2f5', mt: 0, py: 5 }}>
      <Container maxWidth="xl">
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" gap={3}>
          <Box>
            <Typography sx={{ fontWeight: 800 }}>Brendo</Typography>
            <Typography variant="body2" color="text.secondary">
              An open research resource for brain endothelial gene prioritization.
            </Typography>
          </Box>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2.5}>
            <Link href="https://github.com/CompGenomeLab/brendo" target="_blank" rel="noreferrer">GitHub</Link>
            <Link href="https://doi.org/10.1101/2025.10.25.684508" target="_blank" rel="noreferrer">Preprint</Link>
            <Link href="https://adebalilab.org/" target="_blank" rel="noreferrer">Adebali Lab</Link>
            <Link href="https://mustafaoglulab.com/" target="_blank" rel="noreferrer">Mustafaoglu Lab</Link>
          </Stack>
        </Stack>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 3 }}>
          Research-use resource. Gene rankings are hypothesis-generating and do not establish clinical suitability.
        </Typography>
      </Container>
    </Box>
  );
}
